import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import FunderChip from "@/components/borrower/FunderChip";

interface BorrowerNavHeaderProps {
  companyName: string;
  ownerName?: string | null;
  organizationName?: string | null;
}

const BorrowerNavHeader: React.FC<BorrowerNavHeaderProps> = ({
  companyName,
  ownerName,
  organizationName,
}) => {
  const navigate = useNavigate();

  return (
    <div className="mb-3 flex items-center gap-3">
      <button
        type="button"
        className="shrink-0 rounded-md p-1 hover:bg-muted"
        onClick={() => navigate("/applications")}
        aria-label="Back to applications"
      >
        <ArrowLeft className="h-5 w-5" />
      </button>

      <div className="flex min-w-0 flex-1 items-start gap-3 pl-2">
        <div className="min-w-0">
          <h1 className="max-w-[320px] truncate text-xl font-semibold uppercase leading-tight tracking-tight">
            {companyName}
          </h1>
          {ownerName && <p className="text-xs text-muted-foreground">{ownerName}</p>}
        </div>
        <FunderChip organizationName={organizationName} className="mt-1 shrink-0" />
      </div>
    </div>
  );
};

export default BorrowerNavHeader;
